import url from "./url";
const AppConsts = {
  userManagement: {
    defaultAdminUserName: "admin"
  },
  localization: {
    defaultLocalizationSourceName: "GoatBio"
  },
  authorization: {
    encrptedAuthTokenName: "enc_auth_token"
  },
  version: "V1.1.19 - intercom",
  stripe_pk: process.env.NODE_ENV === "production" ? "pk_live_0iHy5C6tAEc7W2KXorE4l6J9006DlTZF5R" : "pk_test_o40hVnhAY7E4yZHCMjVDHgnT00RUkK7S5C",
  environment: process.env.NODE_ENV === "production" ? "PROD" : "TEST",
  lastUpdate: "09/05/2021",
  appBaseUrl: process.env.NODE_ENV === "production" ? "https://app.goatsuccess.com" : process.env.NODE_ENV === "test" ? "https://testapp.goatsuccess.com" : "http://localhost:8080",
  remoteServiceBaseUrl: url
};
export default AppConsts;
